import { createFileRoute } from "@tanstack/react-router";

import FontsPage from "@/app/design-system/fonts/FontsPage";

export const Route = createFileRoute("/admin/design-system/fonts")({
  component: FontsPage,
});
